import { createStyles, makeStyles, Theme } from '@material-ui/core'
import React from 'react'
import { Footer } from '../../shared/components/Footer'
import { Header } from '../../shared/components/Header'
import foerderung from '../../../documents/foerderung.gif'

export const Imprint = (props) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      appContent: {
        minHeight: '86vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        alignItems: 'center',
      },
      dataContainer: {
        marginTop: 30,
        marginLeft: 20,
        marginRight: 20,
      },
      heading: {
        color: '#212121',
        fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
        fontSize: 20,
        textAlign: 'left',
      },
    })
  )
  const classes = useStyles()

  return (
    <div>
      <Header
        page={'imprint'}
        history={props.history}
        selectedLanguage={props.selectedLanguage}
        setSelectedLanguage={props.setSelectedLanguage}
      />

      <div className={classes.appContent}>
        <div className={classes.dataContainer}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ maxWidth: '50%', textAlign: 'left' }}>
              <h1>Impressum</h1>
              <h2>Angaben gemäß § 5 TMG</h2>
              <p>
                IBL-HYDRONIC GmbH und Co. KG<br></br>
                Alte Baumechanik 2<br></br>
                08485 Lengenfeld
              </p>
              <p>
                Handelsregister: HRA 5553<br></br>
                Registergericht: Amtsgericht Chemnitz
              </p>
              <p>
                <strong>Vertreten durch:</strong>
                <br></br>
                IBL-HYDRONIC Verwaltungs GmbH<br></br>
                Alte Baumechanik 2<br></br>
                08485 Lengenfeld
              </p>
              <p>
                Diese vertreten durch:<br></br>
                Herr Dr. Thomas Löcher
              </p>
              <p>
                Handelsregister: HRB22225<br></br>
                Registergericht: Amtsgericht Chemnitz
              </p>
              <h2>Kontakt</h2>
              <p>
                Telefon: +49 (0) 37606 37 82 80<br></br>
                Telefax: +49 (0) 37606 86 95 7<br></br>
                E-Mail: loecher@iblos.com
              </p>
              <h2>Umsatzsteuer-ID</h2>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                Umsatzsteuergesetz:<br></br>
                DE 814 447 095
              </p>
              <h2>Angaben zur Berufshaftpflichtversicherung</h2>
              <p>
                <strong>Name und Sitz des Versicherers:</strong>
                <br></br>
                Gothaer Versicherungsbank VVaG<br></br>
                Arnoldiplatz 1<br></br>
                50969 Köln
              </p>
              <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
              <p>
                IBL-HYDRONIC GmbH &amp; Co. KG<br></br>
                Alte Baumechanik 2<br></br>
                08485 Lengenfeld
              </p>
              <h2>
                Verbraucher­streit­beilegung/Universal­schlichtungs­stelle
              </h2>
              <p>
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
              <h3>Haftung für Inhalte</h3>{' '}
              <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
                Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
                verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
                Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
                gespeicherte fremde Informationen zu überwachen oder nach
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
                hinweisen.
              </p>{' '}
              <p>
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
                Informationen nach den allgemeinen Gesetzen bleiben hiervon
                unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
                Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
                Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
                wir diese Inhalte umgehend entfernen.
              </p>{' '}
              <h3>Haftung für Links</h3>{' '}
              <p>
                Unser Angebot enthält Links zu externen Websites Dritter, auf
                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
                diese fremden Inhalte auch keine Gewähr übernehmen. Für die
                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
                wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
                überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
                Verlinkung nicht erkennbar.
              </p>{' '}
              <p>
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
                jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
                zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
                derartige Links umgehend entfernen.
              </p>{' '}
              <h3>Urheberrecht</h3>{' '}
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
                diesen Seiten unterliegen dem deutschen Urheberrecht. Die
                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten,
                nicht kommerziellen Gebrauch gestattet.
              </p>{' '}
              <p>
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
                wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
                werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
                trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
                bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden
                von Rechtsverletzungen werden wir derartige Inhalte umgehend
                entfernen.
              </p>
              <img
                src={foerderung}
                style={{ marginTop: '20', marginBottom: '20' }}
              />
            </div>
          </div>
        </div>

        <Footer
          history={props.history}
          selectedLanguage={props.selectedLanguage}
        />
      </div>
    </div>
  )
}
